import { apiClient } from "./client";
import type { Service } from "@abejon/shared";

interface ServiceResponse {
  service: Service;
}

interface ServicesResponse {
  services: Service[];
}

export async function getServices(businessId: string) {
  return apiClient<ServicesResponse>(`/services?businessId=${businessId}`);
}

export async function getService(id: string) {
  return apiClient<ServiceResponse>(`/services/${id}`);
}

export async function createService(data: {
  name: string;
  description?: string;
  durationMinutes: number;
  priceInCents: number;
  sortOrder?: number;
}) {
  return apiClient<ServiceResponse>("/services", {
    method: "POST",
    body: data,
  });
}

export async function updateService(
  id: string,
  data: {
    name?: string;
    description?: string;
    durationMinutes?: number;
    priceInCents?: number;
    sortOrder?: number;
  }
) {
  return apiClient<ServiceResponse>(`/services/${id}`, {
    method: "PATCH",
    body: data,
  });
}

export async function deleteService(id: string) {
  return apiClient<{ message: string }>(`/services/${id}`, {
    method: "DELETE",
  });
}

export async function reorderServices(serviceIds: string[]) {
  return apiClient<ServicesResponse>("/services", {
    method: "PATCH",
    body: { serviceIds },
  });
}
